import { Theme } from '@emotion/react';

export const generateButtonStyles = (theme: Theme) => ({
    btn: {
        backgroundColor: theme.palette.primary.primaryDark,
        color: theme.palette.common.white,
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: theme.palette.common.font,
        padding: '12px 16px',
        border: 'none',
        letterSpacing: '0.5px',
        lineHeight: '16px',
        borderRadius: '2px',
        minHeight: '40px',
        cursor: 'pointer',
        textTransform: 'none' as const,
        transition: 'background-color 0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.buttonBlue,
        },
        '&:disabled': {
            backgroundColor: theme.palette.secondary.borderGrey,
            color: theme.palette.secondary.skygrey,
        },
    },
});
